import { connect } from "react-redux";
import React, { useEffect } from "react";
import { Box, CircularProgress } from "@material-ui/core";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import { getFilteredPresentation } from "../../../reducer/presentation/action";

function ListPresentation(props) {
  useEffect(() => {
    props.getFilteredPresentation(1, -1, {
      // accepted: true,
      dashboardYear: props.chosenYear,
      departmentId: props.chosenDepartmentId,
      acceptedOne: true,
    });
  }, [props.chosenYear]);

  const getPresentationType = (type) => {
    switch (type) {
      case "interview_article":
        return "Bài phỏng vấn, bài viết trên báo chí, talkshow, truyền hình";
      case "international_seminar_paper":
        return "Bài trình bày trong hội thảo quốc tế (có xuất bản kỷ yếu)";
      case "national_seminar_paper":
        return "Bài trình bày trong kỷ yếu hội thảo quốc gia";
      case "keynote_international_seminar":
        return "Trình bày keynote tại Hội thảo khoa học quốc tế (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)";
      case "departmental_scientific_activities":
        return "Trình bày tại buổi sinh hoạt khoa học bộ môn/ trình bày tại hội nghị/hội thảo khoa học cấp khoa/viện; Tư vấn doanh nghiệp";
      case "international_seminar_without_proceedings":
        return "Trình bày tại Hội thảo khoa học quốc tế không có bài đăng kỷ yếu khoa học";
      case "national_seminar_with_proceedings":
        return "Trình bày tham luận tại Hội thảo khoa học quốc gia (tài liệu được in trong Kỷ yếu có giấy phép xuất bản)";
      case "scientific_presentation_by_order":
        return "Trình bày/bài viết khoa học theo đơn đặt hàng của Trường hoặc của cơ quan trung ương";
      default:
        return "";
    }
  };

  const getPresentationTitle = (info, index) => {
    return (
      <div key={`presentation-${index}`} style={{ marginTop: 16 }}>
        <div>
          <b style={{ color: "gray" }}>
            {index + 1}. Tên {getPresentationType(info.presentation.type)}:{" "}
          </b>
          <i style={{ color: "red" }}> {info.presentation.title}</i>
        </div>
        <div style={{ marginLeft: 20 }}>
          <b>- Tên hội nghị/hội thảo: </b>
          {info.presentation.conferenceName || ""}
          <br />
          <b>- ISBN: </b>
          {info.presentation.isbn || ""}
          <br />
          <b>- Link: </b>
          {info.presentation.link || ""}
          <br />
          <b>- Đơn vị tổ chức: </b>
          {info.presentation.organizingUnit || ""}
          <br />
          <b>- Địa điểm tổ chức: </b>
          {info.presentation.organizingPlace || ""}
          <br />
        </div>
      </div>
    );
  };

  return props.isFetching ? (
    <div style={{ textAlign: "center" }}>
      <CircularProgress />
    </div>
  ) : (
    <Box paddingRight={1} height="calc(100vh - 214px)" minWidth="calc(100% + 8px)" style={{ overflowY: "auto" }}>
      {props.listPresentationAccepted.map((item, index) => getPresentationTitle(item, index))}
    </Box>
  );
}

const mapStateToProps = (state) => ({
  listPresentationAccepted: select(state, "presentationReducer", "listFiltered"),
  isFetching: select(state, "presentationReducer", "isFetching"),
});

const mapDispatchToProps = (dispatch) => ({
  getFilteredPresentation: (page, pageSize, payload) => dispatch(getFilteredPresentation(page, pageSize, payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(ListPresentation));

